module.exports = "/assets/coke-modal.png?KVH0gha";